export default __webpack_public_path__ + "static/media/arrow.ab7ee7ce.svg";